<template>
  <div class="success-page">
    <div class="success-card">
      <div class="success-icon">
        <i class="iconfont">&#xe681;</i>
      </div>
      <div class="title">
        {{ titleText }}
      </div>
      <div class="desc">
        {{ descText }}
      </div>
      <Button
        type="primary"
        class="view-btn"
        @click="$router.push({ name: 'contributionList' })"
      >
        {{ buttonText }}
      </Button>
    </div>
  </div>
</template>
<script>
import filter from 'js/filter'

export default {
  metaInfo() {
    return {
      title: this.titleText,
    }
  },
  computed: {
    isSaveSuccess() {
      return this.$route.query.from === 'save'
    },
    titleText() {
      return this.isSaveSuccess
        ? filter.dealLanguage('保存成功', 'Saved Successfully')
        : filter.dealLanguage('提交成功', 'Submitted Successfully')
    },
    descText() {
      return this.isSaveSuccess
        ? filter.dealLanguage('您已成功保存摘要内容', 'Your abstract has been saved successfully.')
        : filter.dealLanguage('您已成功提交摘要内容', 'Your abstract has been submitted successfully.')
    },
    buttonText() {
      return this.isSaveSuccess
        ? filter.dealLanguage('查看已保存的摘要', 'View Saved Abstracts')
        : filter.dealLanguage('查看已提交的摘要', 'View Submitted Abstracts')
    },
  },
}
</script>
<style lang="stylus" scoped>
.success-page
  min-height calc(100vh - 1.22rem)
  display flex
  align-items center
  justify-content center
  padding 0.6rem 0.4rem
  background #F7F7F7

.success-card
  width 100%
  text-align center

.success-icon
  width 1.4rem
  height 1.4rem
  margin 0 auto
  border 0.12rem solid #2BC15D
  border-radius 50%
  display flex
  align-items center
  justify-content center
  color #2BC15D
  .iconfont
    font-size 1.4rem
    line-height 1

.title
  margin-top 0.42rem
  font-weight 600
  font-size 0.52rem
  color #3D3D3D
  line-height 0.72rem

.desc
  margin-top 0.24rem
  font-size 0.3rem
  color #666666
  line-height 0.44rem

.view-btn
  margin-top 0.56rem
  min-width 3.6rem
  height 0.88rem
  color #fff
  background-color #C8161D
  border-color #C8161D
  border-radius .08rem
  font-size .28rem
  line-height: 1;
  border: 0
  &:hover
    background-color #E24147
    border-color #E24147
</style>
